import { DATE_TIME_FORMAT } from 'utils/constants';
import companiesTransformer from 'modules/account/contact/transformers/companiesTransformer';
import { Lead } from 'utils/types';
import { dayjs } from 'utils/providers/Timezone';

const lead = ({
  data: { _id, createdAt, updatedAt, accountUserId, companyId, ...rest },
}: {
  data: Lead;
}) => ({
  data: {
    ...rest,
    id: _id,
    accountUserId,
    ...(companyId && {
      companyId:
        typeof companyId === 'string'
          ? companyId
          : {
              ...companiesTransformer.company(companyId as any),
            },
    }),
    createdAt: dayjs(createdAt).format(DATE_TIME_FORMAT),
    updatedAt: dayjs(updatedAt).format(DATE_TIME_FORMAT),
  },
});

const leads = ({ data, meta }: { data: Lead[]; meta: any }) => ({
  meta,
  data: data.map((dat) => lead({ data: dat })?.data),
});

export default { lead, leads };
